import React from 'react'

class SoldItemsList extends React.Component {
  render() {
    const { auth } = this.props

    return (
      <div className="table-responsive">
        <table className="table table-sm table-stripped">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Código</th>
              <th scope="col">Cantidad</th>
              {auth.type === 'ROOT' || auth.type === 'GOD' &&
                <th scope="col">Precio (PVP)</th>
              }
            </tr>
          </thead>
          <tbody>
            {this.props.items.map(item => (
              <tr key={item.item.code}>
                <th scope="row">{item.item}</th>
                <td>{item.qty}</td>
                {auth.type === 'ROOT' || auth.type === 'GOD' &&
                  <td>{`${parseFloat(item.price).toFixed(2)} €`}</td>
                }
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}

export default SoldItemsList

